module.exports = __webpack_public_path__ + "img/mobile-46.cc13cf9d.png";